import { brand } from '../../theme/chakra';

/**
 * ProviderHome color aliases — aligned to the design-system brand tokens.
 *
 * These were a parallel off-token palette (hand-sampled hex tuned to Kate's
 * Figma). Each is now pinned to its nearest NON-legacy brand token from
 * `src/theme/chakra.ts`, so the Home page pulls from the shared theme
 * instead of a private one. Kept as named aliases (not inlined) so intent
 * stays readable at call sites, and resolved to the brand *value* (not the
 * token name) because some consumers pass these to lucide icons, which need
 * a real color rather than a Chakra token name.
 *
 * Known palette gaps this alignment exposes (see design-system audit →
 * Archive → Aligned off-token colors): the brand palette has no neutral
 * near-black or neutral mid-gray, so INK / SUBTLE_STRONG land on the teal
 * brand darks (evergreen / seafoam) rather than a true neutral.
 */
export const INK = brand.evergreen; // was #20262A — no neutral near-black in palette
export const SUBTLE = brand.bluegrey; // was #8B9298
export const SUBTLE_STRONG = brand.seafoam; // was #5C646A — no neutral mid-gray in palette
export const TEAL = brand.aqua; // was #5299A9 (exact match)
export const PLUM = brand.fuschia; // was #873A5C
export const ACTIVE_BG = brand.mint; // was #E7F0F1
export const ACTIVE_BORDER = brand.steel; // was #BBD9DC
export const ACTIVE_BAR = brand.seafoam; // was #2D6670 (exact match)
export const CARD_BORDER = brand.cloud; // was #ECECEC
